module.exports = __webpack_public_path__ + "img/Stuffing Level.3c0171f4.svg";